import { render, staticRenderFns } from "./SpreadLonger.vue?vue&type=template&id=0f29f0f8&scoped=true&"
import script from "./SpreadLonger.vue?vue&type=script&lang=js&"
export * from "./SpreadLonger.vue?vue&type=script&lang=js&"
import style0 from "./SpreadLonger.vue?vue&type=style&index=0&id=0f29f0f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29f0f8",
  null
  
)

export default component.exports